import React from 'react';

/**
 * Shows a map render error instead of taking the page down with it.
 *
 * The map has more ways to fail than the rest of this page — a malformed
 * polyline, Maps not loading, a sprite built before Google's constructors
 * exist — and React unmounts the whole tree on a render error. Without this,
 * one of those blanked the ride's details and event log too, which is where
 * support is actually working.
 */
class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }
    return (
      <pre data-testid="sim-error" style={{ padding: 16, color: '#ff6b6b', whiteSpace: 'pre-wrap', fontSize: 12 }}>
        {String(error && error.stack ? error.stack : error)}
      </pre>
    );
  }
}

export default MapErrorBoundary;
